import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Action from "../../Action";

import * as style from './style.module.css';

// [{title, action, icon}]

const CardActions = ({ actions = [] }) => actions.length === 0 ? null : <div className={style.shadow} ><div className={style.container}>
    
    {actions.map(e => <Action key={e.title} className={style.action} action={e.action}>
        {e.icon && <FontAwesomeIcon icon={e.icon} />}
        {e.title}
    </Action>)}
</div></div>

export default CardActions;
